import React from 'react';

import { CloseSvg } from '../common/svg';

import '../../styles/common/modal.scss';

const Modal = (props) => (
  <div className="modal-wrapper">
    <button
      className="close-button"
      onClick={props.closeModal}
    >
      { CloseSvg }
    </button>
    <div className="modal-box">
      <div className="modal-sizer">
        <div className="modal-contents">
          {props.content}
        </div>
      </div>
    </div>
    <div
      className="modal-shade"
      onClick={props.closeModal}
      aria-hidden={true}
    />
  </div>
);

export default Modal;